import React, { Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Button, TextField, Grid, Typography } from "@material-ui/core";
import FacebookPageDialog from "../../components/widget/FacebookPageDialog";
import FacebookPageDialog2 from "../../components/widget/FacebookPageDialog2";
import InstagramPageDialog from "../../components/widget/InstagramPageDialog";

import EmbedGigWidget from "../../components/widget/EmbedGigWidget";
import Loading from "../loadingSpinner/Loading";
import { withRouter } from "react-router-dom";

import EntertainmentGigWidget from "../widget/EntertainmentGigWidget";
import EntertainmentGigVenueWidget from "../widget/EntertainmentGigVenueWidget";

import GoogleCalendarPart from "../../pages/setting/component/googleCalendarPart.js"
import { ProfileType } from "../../types/enum";
import SectionHeader from "../common/SectionHeader";
import IntegrationCard from "../common/IntegrationCard";
import CodeBlock from "../common/CodeBlock";
import "./Social.css";

const IS_MOBILE = process.env.REACT_APP_IS_MOBILE === "true";
const FACEBOOK_ENABLED = process.env.REACT_APP_FACEBOOK_ENABLED === "true";
const ENV = process.env.REACT_APP_BASE_URL

@inject("socialProfileStore", "templateStore", "authStore", "profileStore", "googleCalendarStore", "instagramStore", "hgBillingStore")
@withRouter
@observer
class Social extends React.Component {
    state = {
        isLoading: true,
        isLoaded: false,
        isGoogleRedirect : false,
    };

    componentDidMount() {
        const currentProfile = this.props.profileStore.getCurrentProfile();;
        const {instagramCode} = this.props.instagramStore
        window.scrollTo(0, 0);
        if(this.props.googleCalendarStore.googleCalendarCode){
            this.setState({ isGoogleRedirect: true });
        }else{
            this.setState({ isGoogleRedirect: false });
        }

        if (instagramCode) {
            var data = {
                code : instagramCode,
                profileId : currentProfile?.id
            }
            this.props.instagramStore
            .exchangeToken(data)
            .then(() => {
                this.props.socialProfileStore.setType(this.props.templateStore.getType(this.props.type));
                this.props.socialProfileStore
                    .loadInitialData(this.props.profileId)
                    .then(() => {})

            })
            .finally(() => {
                this.setState({ isLoading: false, isLoaded: true });
                window.scrollTo(0, 0);
            });
            
        }else{
            this.loadSocial();
        }
        // set type
            
    }

    
    loadSocial = () => {
        this.props.socialProfileStore.setType(this.props.templateStore.getType(this.props.type));
        this.props.socialProfileStore
            .loadInitialData(this.props.profileId)
            .then(() => {})
            .finally(() => {
                this.setState({ isLoading: false, isLoaded: true });
                window.scrollTo(0, 0);
            });
    }
    

    handleBack = () => {
        if (this.props.type === "venue") {
            const { profile } = this.props.profileStore;
            this.props.history.push(`/venues/${profile.id}/edit/financial`);
        }
        if (this.props.type === "act") {
            this.props.history.replace(`/myact/edit/${this.props.match.params.id}/design`);
        }
        const { editProfileActiveStep } = this.props.templateStore;
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep - 1);
    };

    redirectToMembership = () => {
        this.props.history.replace(`/account/setting/membership`);
        
    }

    handleSubmitForm = e => {
        e.preventDefault();

        this.setState({ isLoading: true });
       
        this.props.socialProfileStore.submit().then(resp => {
            if (this.props.type === "venue") {
                this.props.history.push(`/venues/${resp.id}/edit/member`);
            }
            if (this.props.type === "act") {
                this.props.history.push(`/myact/edit/${resp.id}/lineup`);
            }
            if (this.props.type !== "act" && this.props.type !== "venue") {
                const { editProfileActiveStep } = this.props.templateStore;
                this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep + 1);
            }
        });
    };

    anyError(field) {
        if (!this.props.socialProfileStore.errors) return false;
        if (!this.props.socialProfileStore.errors[field]) return false;
        return true;
    }

    errorText(field) {
        if (!this.props.socialProfileStore.errors) return null;
        if (!this.props.socialProfileStore.errors[field]) return null;
        return this.props.socialProfileStore.errors[field];
    }

    render() {
        const { editProfileActiveStep } = this.props.templateStore;
        const type = this.props.type;
        const steps = this.props.templateStore.getSteps(type);
        const { isLoading,isLoaded } = this.state;
        const currentProfile = this.props.profileStore.getCurrentProfile()
        const { profile } = this.props.profileStore;
        const {billingAccess} = this.props.hgBillingStore

        const isInstagramConnected = Boolean(profile?.instagramId && profile?.instagramProfile);
        const isFacebookConnected = Boolean(profile?.facebookPageName);
        const googleCalendarProfile = type === "venue" ? this.props.socialProfileStore.profile : profile;
        const isGoogleCalendarConnected = Boolean(
            googleCalendarProfile?.activateGoogleCalendar && googleCalendarProfile?.googleCalendarName
        );

        return (
            <div className="Profile-Social">
                <form onSubmit={this.handleSubmitForm} className="form-relative">
                    <Loading showed={isLoading} />
                    <Grid container spacing={24}>
                      

                        <Fragment>
                            <Grid item xs={12} lg={12}>
                                <SectionHeader
                                    title="Embed Your Upcoming Gigs On Your Website"
                                    helpText="Copy this code and paste it into your website's HTML to display your upcoming gigs. You can customise the colours of your gig guide using the 'Customise Widget' button."
                                />
                                <Grid container spacing={8}>
                                    <Grid item xs={12} md={12}>
                                    {
                                        currentProfile?.type != ProfileType.Musician.ordinal && (!billingAccess || billingAccess?.isFreePlan) ? (
                                            <div className="upgrade-prompt-card">
                                                <Typography variant="h6" className="upgrade-title">
                                                    Upgrade to Access This Feature
                                                </Typography>
                                                <Typography variant="body2" className="upgrade-description">
                                                    The gig widget embed feature is only available with the {currentProfile?.type === ProfileType.Musician.ordinal ? "Entertainer" : currentProfile?.type === ProfileType.Agent.ordinal ? "Agent" : "Staff" } Pro plan.
                                                </Typography>
                                                <Button variant="contained" color="primary" onClick={this.redirectToMembership}>
                                                    Upgrade to Pro
                                                </Button>
                                            </div>
                                        ) : 
                                        <EmbedGigWidget profileId={this.props.socialProfileStore.id} />
                                    }
                                        
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Fragment>

                        {
                            type === 'venue' && (
                                <Fragment>
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title="Display Your Upcoming Gigs on Venue Screens"
                                            helpText="Use this URL in your digital signage solution to automatically display your upcoming gigs on screens in your venue"
                                        />
                                        <Grid container spacing={8}>
                                            <Grid item xs={12} md={12}>
                                            {
                                                currentProfile?.type != ProfileType.Musician.ordinal && (!billingAccess || billingAccess?.isFreePlan) ? (
                                                    <div className="upgrade-prompt-card">
                                                        <Typography variant="h6" className="upgrade-title">
                                                            Upgrade to Access This Feature
                                                        </Typography>
                                                        <Typography variant="body2" className="upgrade-description">
                                                            This feature is only available with the {currentProfile?.type === ProfileType.Musician.ordinal ? "Entertainer" : currentProfile?.type === ProfileType.Agent.ordinal ? "Agent" : "Staff" } Pro plan.
                                                        </Typography>
                                                        <Button variant="contained" color="primary" onClick={this.redirectToMembership}>
                                                            Upgrade to Pro
                                                        </Button>
                                                    </div>
                                                ) : 
                                                <EntertainmentGigWidget profileId={this.props.socialProfileStore.id} />
                                            }
                                                
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                {
                                                    currentProfile?.type != ProfileType.Musician.ordinal && (!billingAccess || billingAccess?.isFreePlan) ? null : 
                                                      <EntertainmentGigVenueWidget profileId={this.props.socialProfileStore.id} />
                                                }
                                              
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment> 
                            )
                        }

                        {FACEBOOK_ENABLED && (
                            <Fragment>
                                <Grid item xs={12} lg={12}>
                                    <SectionHeader
                                        title="Social Media Integrations"
                                        helpText="Connect your social media accounts to automatically share your upcoming gigs with your followers."
                                    />
                                    <div className="integration-cards-grid">
                                        <IntegrationCard
                                            iconType="instagram"
                                            title="Instagram"
                                            description="Automatically share your upcoming gigs to your Instagram business account. Keep your followers updated with your latest performances."
                                            isConnected={isInstagramConnected}
                                            connectedAccount={profile?.instagramProfile ? `@${profile.instagramProfile}` : null}
                                            connectButton={
                                                !IS_MOBILE ? (
                                                    <FacebookPageDialog2 refresh={this.loadSocial} isGoogleRedirect={this.state.isGoogleRedirect}/>
                                                ) : (
                                                    <Typography variant="body2" className="mobile-connect-note">
                                                        To connect your Instagram account, please use the web interface. <a href="#" onClick={() => window.open('https://get.hotgiggity.com/sign-in', '_system')}>Sign in here</a>
                                                    </Typography>
                                                )
                                            }
                                            disconnectButton={
                                                !IS_MOBILE ? (
                                                    <FacebookPageDialog2 disconnectOnly refresh={this.loadSocial} isGoogleRedirect={this.state.isGoogleRedirect}/>
                                                ) : null
                                            }
                                        />
                                        <IntegrationCard
                                            iconType="facebook"
                                            title="Facebook"
                                            description="Post your gigs directly to your Facebook business page. Reach more fans and fill more seats at your performances."
                                            isConnected={isFacebookConnected}
                                            connectedAccount={profile?.facebookPageName || null}
                                            connectButton={
                                                !IS_MOBILE ? (
                                                    <FacebookPageDialog refresh={this.loadSocial} isGoogleRedirect={this.state.isGoogleRedirect}/>
                                                ) : (
                                                    <Typography variant="body2" className="mobile-connect-note">
                                                        To connect your Facebook account, please use the web interface. <a href="#" onClick={() => window.open('https://get.hotgiggity.com/sign-in', '_system')}>Sign in here</a>
                                                    </Typography>
                                                )
                                            }
                                            disconnectButton={
                                                !IS_MOBILE ? (
                                                    <FacebookPageDialog disconnectOnly refresh={this.loadSocial} isGoogleRedirect={this.state.isGoogleRedirect}/>
                                                ) : null
                                            }
                                        />
                                    </div>
                                </Grid>
                            </Fragment>
                        )}

                        {isLoaded  &&
                            process.env.REACT_APP_GOOGLE_CALENDAR_ACTIVATE === "true" &&  (type === 'musician' ||  type === 'venue') && (
                                <Fragment>
                                    <Grid item xs={12} lg={12}>
                                        <SectionHeader
                                            title="Calendar Integration"
                                            helpText="Sync your Hot Giggity calendar with external calendar services for seamless schedule management."
                                        />
                                        <div className="integration-cards-grid single-card">
                                            <IntegrationCard
                                                iconType="google"
                                                title="Google Calendar"
                                                description="Two-way sync between Hot Giggity and Google Calendar. Your gigs appear in Google Calendar, and Google events show as 'Unavailable' in Hot Giggity."
                                                isConnected={isGoogleCalendarConnected}
                                                connectedAccount={isGoogleCalendarConnected ? googleCalendarProfile.googleCalendarName : null}
                                                connectButton={
                                                    !IS_MOBILE ? (
                                                        <GoogleCalendarPart profileId={this.props.profileId} type={this.props.type} />
                                                    ) : (
                                                        <Typography variant="body2" className="mobile-connect-note">
                                                            To connect your Google Calendar account, please use the web interface. <a href="#" onClick={() => window.open('https://get.hotgiggity.com/sign-in', '_system')}>Sign in here</a>
                                                        </Typography>
                                                    )
                                                }
                                                disconnectButton={
                                                    !IS_MOBILE ? (
                                                        <GoogleCalendarPart
                                                            disconnectOnly
                                                            refresh={this.loadSocial}
                                                            profileId={this.props.profileId}
                                                            type={this.props.type}
                                                        />
                                                    ) : null
                                                }
                                            >
                                                <div className="calendar-features">
                                                    <div className="feature-item">
                                                        <span className="feature-check">✓</span>
                                                        <span>Hot Giggity events appear in Google Calendar</span>
                                                    </div>
                                                    <div className="feature-item">
                                                        <span className="feature-check">✓</span>
                                                        <span>Google Calendar events shown as "Unavailable"</span>
                                                    </div>
                                                </div>
                                            </IntegrationCard>
                                        </div>
                                    </Grid>
                                </Fragment>
                            )}
                        <Fragment>
                            <Grid item xs={12} lg={12}>
                                <div className="action">
                                    <Button disabled={editProfileActiveStep === 0} onClick={this.handleBack}>
                                        Back
                                    </Button>
                                    <Button variant="contained" color="primary" type="submit" id="submit-social">
                                        {editProfileActiveStep === steps.length - 1 ? "Finish" : "Save/Next"}
                                    </Button>
                                </div>
                            </Grid>
                        </Fragment>
                    </Grid>
                </form>
            </div>
        );
    }
}

export default Social;
